import { useCallback } from "react";
import { SearchDialogStatesType } from "../states/dialogs";

export const useSearchReportInputDialogHandlers = (
  dialogStates: SearchDialogStatesType
) => {
  const onClose = useCallback(() => {
    dialogStates.setReportInputDialogMode(undefined);
    dialogStates.setReportInputDialogEstateId(undefined);
  }, [dialogStates]);

  const onOkButtonClick = useCallback(() => {
    onClose();
  }, [onClose]);

  return {
    onClose,
    onOkButtonClick
  } as const;
};

export type SearchReportInputDialogHandlersType = ReturnType<
  typeof useSearchReportInputDialogHandlers
>;
